/**
 * Generated runtime TestId mirror for frontend/src/pages/RestrictionRuleRequestCreateWizard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RestrictionRuleRequestCreateWizardTestIds = {
  abandonDialogTitle: "abandon-dialog-title",
  btnAbandonConfirm: "btn-abandon-confirm",
  btnAbandonStay: "btn-abandon-stay",
  btnNextStep: "btn-next-step",
  btnPreviousStep: "btn-previous-step",
  btnProfileModeCondition: "btn-profile-mode-condition",
  btnProfileModeList: "btn-profile-mode-list",
  btnRunTest: "btn-run-test",
  btnSkipTest: "btn-skip-test",
  btnSubmit: "btn-submit",
  btnToggleHelp: "btn-toggle-help",
  btnViewAffected: "btn-view-affected",
  conditionEmptyWarning: "condition-empty-warning",
  errorName: "error-name",
  errorOwner: "error-owner",
  expressionInvalidIndicator: "expression-invalid-indicator",
  expressionNetworkError: "expression-network-error",
  expressionValidIndicator: "expression-valid-indicator",
  expressionValidating: "expression-validating",
  graceDaysPicker: "grace-days-picker",
  inputConditionExpr: "input-condition-expr",
  inputDescription: "input-description",
  inputName: "input-name",
  inputProfileCondition: "input-profile-condition",
  inputProfileSearch: "input-profile-search",
  noProfilesSelected: "no-profiles-selected",
  notTestedNote: "not-tested-note",
  pageRestrictionRuleRequestCreateWizard: "page-restriction-rule-request-create-wizard",
  profileModeToggle: "profile-mode-toggle",
  restrictionRuleRequestStepContainer: "restriction-rule-request-step-container",
  reviewTestSummary: "review-test-summary",
  selectedProfilesList: "selected-profiles-list",
  testResultsSuccess: "test-results-success",
  thTestResultIdentity: "th-test-result-identity",
  thTestResultOwner: "th-test-result-owner",
  btnGraceDays: (days: string) => `btn-grace-days-${days}`,
  btnGraceDaysPrefix: () => "btn-grace-days-" as TestIdPrefix,
  btnRemoveProfile: (profile_id: string) => `btn-remove-profile-${profile_id}`,
  btnRemoveProfilePrefix: () => "btn-remove-profile-" as TestIdPrefix,
  checkboxProfile: (profile_id: string) => `checkbox-profile-${profile_id}`,
  checkboxProfilePrefix: () => "checkbox-profile-" as TestIdPrefix,
  linkIdentityDetail: (item_identity_id: string) => `link-identity-detail-${item_identity_id}`,
  linkIdentityDetailPrefix: () => "link-identity-detail-" as TestIdPrefix,
  linkPartyDetail: (item_party_id: string) => `link-party-detail-${item_party_id}`,
  linkPartyDetailPrefix: () => "link-party-detail-" as TestIdPrefix,
  rowProfile: (profile_id: string) => `row-profile-${profile_id}`,
  rowProfilePrefix: () => "row-profile-" as TestIdPrefix,
  expressionError: (index: number) => `expression-error-${index}`,
  expressionErrorPrefix: () => "expression-error-" as TestIdPrefix
} as const;
